// ═══════════════════════════════════════════════════════════════════════════
// 🗂️ MEMORY CARTELLE VIEW - Vista Cartelle con layout identico a Foto
// ═══════════════════════════════════════════════════════════════════════════

import React, { useState } from 'react';
import CategoryDistributionBar from './CategoryDistributionBar';
import FilterPills from './FilterPills';
import CategoryAccordion from './CategoryAccordion';

/**
 * Vista Cartelle - Esplora ricordi per categoria
 * Layout IDENTICO alla vista Foto
 *
 * @param {Array} memories - Array di ricordi
 * @param {function} onEdit - Callback edit ricordo
 */
function MemoryCartelleView({ memories, onEdit }) {
  const [selectedFilter, setSelectedFilter] = useState('all');
  const [expandedCategories, setExpandedCategories] = useState([]);

  // ─────────────────────────────────────────────────────────────────────────
  // RAGGRUPPA PER CATEGORIA
  // ─────────────────────────────────────────────────────────────────────────

  const grouped = memories.reduce((acc, m) => {
    const cat = m.category || 'Generale';
    if (!acc[cat]) acc[cat] = [];
    acc[cat].push(m);
    return acc;
  }, {});

  // Conta per categoria
  const counts = Object.entries(grouped).reduce((acc, [cat, mems]) => {
    acc[cat] = mems.length;
    return acc;
  }, {});

  // ─────────────────────────────────────────────────────────────────────────
  // FILTRA
  // ─────────────────────────────────────────────────────────────────────────

  const filteredGrouped =
    selectedFilter === 'all' ? grouped : { [selectedFilter]: grouped[selectedFilter] || [] };

  // ─────────────────────────────────────────────────────────────────────────
  // TOGGLE CATEGORIA
  // ─────────────────────────────────────────────────────────────────────────

  const toggleCategory = (cat) => {
    setExpandedCategories((prev) =>
      prev.includes(cat) ? prev.filter((c) => c !== cat) : [...prev, cat]
    );
  };

  // ─────────────────────────────────────────────────────────────────────────
  // RENDER
  // ─────────────────────────────────────────────────────────────────────────

  if (!memories || memories.length === 0) {
    return (
      <div style={styles.empty}>
        <p>Nessun ricordo disponibile</p>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {/* Barra distribuzione */}
      <CategoryDistributionBar data={counts} type="ricordi" />

      {/* Pills filtri */}
      <FilterPills categories={counts} selected={selectedFilter} onChange={setSelectedFilter} />

      {/* Accordion categorie */}
      <div style={styles.accordionList}>
        {Object.entries(filteredGrouped)
          .sort(([a], [b]) => a.localeCompare(b))
          .map(([cat, mems]) => (
            <CategoryAccordion
              key={cat}
              category={cat}
              count={mems.length}
              memories={mems}
              isExpanded={expandedCategories.includes(cat)}
              onToggle={() => toggleCategory(cat)}
              onEdit={onEdit}
            />
          ))}
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════
// 🎨 STYLES
// ═══════════════════════════════════════════════════════════════════════════

const styles = {
  container: {
    padding: '0',
  },

  accordionList: {
    display: 'flex',
    flexDirection: 'column',
  },

  empty: {
    padding: '64px 16px',
    textAlign: 'center',
    color: '#A3A3A3',
    fontSize: '14px',
    fontStyle: 'italic',
  },
};

export default MemoryCartelleView;
